import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  sliceFrom: '',
  sliceTo: '',
  response: {},
  sliceResponse: null,
  errorCode: 0,
  errorMsg: '',
  isFetching: true,
  invalidResponse: true,
  isSliceFetching: true,
  lastSliceFrom: '',
  lastSliceTo: '',
  lastSliderFrom: 0,
  lastSliderTo: 0,
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $merge: {
    sliceFrom: '',
    sliceTo: '',
    response: {},
    sliceResponse: null,
    errorCode: 0,
    errorMsg: '',
    isFetching: true,
    invalidResponse: true,
    isSliceFetching: true,
  },
});

switchMap[types.SET_SLICE_INTERVAL] = (state, action) => update(state, {
  $merge: {
    sliceFrom: action.from,
    sliceTo: action.to,
  },
});

switchMap[types.RESET_SLICE_INTERVAL] = state => update(state, {
  $merge: {
    sliceFrom: '',
    sliceTo: '',
    invalidResponse: true,
    sliceResponse: null,
    isSliceFetching: true,
  },
});

switchMap[types.SET_SHARING_STATE] = (state, action) => update(state, {
  $merge: action.sharingState,
});

switchMap[types.FETCHING] = state => update(state, {
  isFetching: {
    $set: true,
  },
});

switchMap[types.FETCHING_SUCCESS] = (state, action) => update(state, {
  $merge: {
    response: action.response,
    isFetching: false,
    errorCode: 0,
    errorMsg: '',
    invalidResponse: false,
  },
});

switchMap[types.FETCHING_FAILS] = (state, action) => update(state, {
  $merge: {
    response: null,
    isFetching: false,
    errorCode: action.errorCode || 500,
    errorMsg: action.errorMsg || 'Unknown error.',
    invalidResponse: true,
  },
});

switchMap[types.FETCHING_SLICE] = state => update(state, {
  isSliceFetching: {
    $set: true,
  },
});

switchMap[types.FETCHING_SLICE_SUCCESS] = (state, action) => update(state, {
  $merge: {
    isSliceFetching: false,
    sliceResponse: action.sliceResponse,
  },
});

switchMap[types.FETCHING_SLICE_FAILS] = (state, action) => update(state, {
  $merge: {
    response: null,
    isSliceFetching: false,
    errorCode: action.errorCode || 500,
    errorMsg: action.errorMsg || 'Unknown error.',
  },
});

switchMap[types.RESET_RESPONSE] = state => update(state, {
  $merge: {
    response: null,
    invalidResponse: true,
  },
});

switchMap[types.SET_INVALID_RESPONSE] = (state, action) => update(state, {
  invalidResponse: {
    $set: action.invalidResponse,
  },
});

switchMap[types.SAVE_TRENDS_DIAGNOSTICS_SLICE] = (state, action) => update(state, {
  lastSliceFrom: {
    $set: action.sliceFrom,
  },
  lastSliceTo: {
    $set: action.sliceTo,
  },
});

switchMap[types.SAVE_TRENDS_DIAGNOSTICS_SLIDER] = (state, action) => update(state, {
  lastSliderFrom: {
    $set: action.sliderFrom,
  },
  lastSliderTo: {
    $set: action.sliderTo,
  },
});


export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
